import { request } from "services/api/util";

class MobileAppSupportedVersionService {
  async getMobileAppSupportedVersion() {
    const config = {
      method: "get",
      url: `admin/mobileSupportedVersions`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async setMobileAppSupportedVersion(body) {
    let config;
    config = {
      method: "post",
      url: `admin/mobileSupportedVersions`,
      data: body,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };
    return request(config);
  }
}

export default new MobileAppSupportedVersionService();
